import { lazy } from 'react';
import { Loadable } from '@planitgeo/treeplotter-ui-library';
import { loadableFallback } from 'utils/loadableFallback';

export const AssetClassPage = Loadable(
  lazy(() => import('assetClass/presentation/AssetClassPage')),
  loadableFallback
);
export const AssetClassRecordEditablePage = Loadable(
  lazy(() => import('assetClass/presentation/asset/RecordEditablePage')),
  loadableFallback
);
export const AssetNewPage = Loadable(
  lazy(() => import('assetClass/presentation/asset/newPage')),
  loadableFallback
);
export const SettingsPage = Loadable(
  lazy(() => import('common/presentation/baseLayout/settings/SettingsPage')),
  loadableFallback
);
export const NoTenantPage = Loadable(
  lazy(() => import('common/presentation/NoTenantPage')),
  loadableFallback
);
